import Swipes from './Swipes';

export default Swipes;
